import type { AppInventoryOptionType } from '@openx/types/targeting/appInventory';
import type { InventoryContentOption } from '@openx/types/targeting/inventoryAndContent';
import type { ComparisonType } from '@openx/types/targeting/targetingValuesTypes';
import { comparisonOptions } from '../constants';

export const ifComparisonOptionDoesntExist = (
  value: ComparisonType | null,
  option: InventoryContentOption | AppInventoryOptionType
): boolean => !comparisonOptions[option]?.includes(value);
